import SessionStorage from "../storage/SessionStorage";
import { messages } from "../localization/messages";

class NotificationUtils {
  static _browserSupportsNotifications() {
    return "Notification" in window;
  }

  static _notificationsAllowed() {
    return Notification.permission === "granted";
  }

  static _notificationsBlocked() {
    return Notification.permission === "denied";
  }

  static _notificationsUseable() {
    return (
      NotificationUtils._browserSupportsNotifications &&
      NotificationUtils._notificationsAllowed
    );
  }

  static requestForNotificationsPermission() {
    const supportChecked = SessionStorage.retreive(
      "NotificationSupportChecked"
    );

    if (
      NotificationUtils._browserSupportsNotifications() &&
      !NotificationUtils._notificationsBlocked() &&
      !NotificationUtils._notificationsAllowed()
    ) {
      Notification.requestPermission();
    }

    if (!supportChecked) {
      SessionStorage.persist("NotificationSupportChecked", true);

      if (!NotificationUtils._browserSupportsNotifications()) {
        alert(messages.notificationsUnsupportedMessage);
      }
    }
  }

  static showNotification(title, text, onClick) {
    if (NotificationUtils._notificationsUseable()) {
      const options = {
        body: text,
        vibrate: true
      };
      var notification = new Notification(title, options);
      notification.onclick = onClick;
    }
  }
}

export default NotificationUtils;
